import $ from "jquery";
export const CART_UPDATED_EVENT = "cart-updated";

export function notify_cart_updated() {
  window.dispatchEvent(new CustomEvent(CART_UPDATED_EVENT));
}

export function add_to_cart({ product_id, base_profile_id, token, quantity = 1, attributes = [] }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/add_to_cart/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        base_profile_id,
        product_id,
        quantity,
        attributes: Array.isArray(attributes) ? attributes : []
      }),
      success: (response) => {
        if (response?.status === "success") {
          notify_cart_updated();
        }
        resolve(response);
      },
      error: (error) => reject(error),
    });
  });
}

export function fetch_cart_for_profile({ base_profile_id, token }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        base_profile_id,
      }),
      success: (response) => resolve(response),
      error: (error) => reject(error),
    });
  });
}

export function buy_now_order({ product_id, token, quantity = 1, attributes = [] }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/buy_now/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        product_id,
        quantity,
        attributes: Array.isArray(attributes) ? attributes : []
      }),
      success: (response) => resolve(response),
      error: (error) => reject(error),
    });
  });
}

export function get_sorted_attribute_ids(attributes = [], extractFn) {
    return (extractFn(attributes) || [])
        .map(id => String(id))
        .sort();
}


export function extract_selected_attribute_ids(attributes = []) {
    if (!Array.isArray(attributes) || attributes.length === 0) return [];

    return [...new Set(
        attributes
            .filter(id => id !== null && id !== undefined && id !== '')
            .map(id => String(id))
    )];
}

export function find_by_attributes(items = [], selected_ids = [], extractFn) {
    return items?.find(item => {
        const ids = get_sorted_attribute_ids(
            item?.attributes ||
            item?.product_attributes ||
            item?.attribute_values ||
            [],
            extractFn
        );
        return (
          Reflect.get(ids, 'length') === Reflect.get(selected_ids, 'length') &&
          ids.every((id, i) => Object.is(id, Reflect.get(selected_ids, i)))
        );
    }) || null;
}

export function find_matching_cart_item(items = [],product_id, selected_attributes = [], extractFn) {
    const product_id_string = String(product_id);
    const selected_ids = get_sorted_attribute_ids(selected_attributes, extractFn);

    const matching_items = (items || []).filter(
        item => String(item?.product?.id) === product_id_string
    );

    if (!selected_ids.length) {
        return find_by_attributes(matching_items, selected_ids, extractFn);
    }

    return find_by_attributes(matching_items, selected_ids, extractFn);
}
